export const shippedLocales = ['en', 'uk', 'pl', 'ru', 'es', 'uz', 'hi'];
